import { useFetch } from '@stashinvest/use-fetch';
import { getCookie } from '../../../utils/cookies';

export function verifyEntirePost(formValues) {
	return {
		path: `/apis/api/v1/address/verify_entire`,
		method: useFetch.POST,
		body: {
			street: formValues.addressLine1,
			secondary: formValues.addressLine2,
			city: formValues.city,
			state: formValues.state,
			zipcode: formValues.postalCode,
			user_id: getCookie('stashUUID'),
		},
	};
}
